import { z } from 'zod';

export const BORDER_SHAPE = {
  borderStyle: z.enum(['solid', 'dashed', 'dotted', 'double']).optional().nullable(),
  borderWidths: z
    .object({
      top: z.number().nonnegative(),
      right: z.number().nonnegative(),
      bottom: z.number().nonnegative(),
      left: z.number().nonnegative(),
    })
    .optional()
    .nullable(),
};

type BorderProps = z.infer<z.ZodObject<typeof BORDER_SHAPE>> & {
  borderColor?: string | null;
};

export function getBorderStyles(props?: BorderProps | null) {
  if (!props?.borderColor) return {};

  const borderStyle = props.borderStyle ?? 'solid';
  const borderWidths = props.borderWidths;
  if (!borderWidths) return { border: `1px ${borderStyle} ${props.borderColor}` };

  return {
    borderTop: `${borderWidths.top}px ${borderStyle} ${props.borderColor}`,
    borderRight: `${borderWidths.right}px ${borderStyle} ${props.borderColor}`,
    borderBottom: `${borderWidths.bottom}px ${borderStyle} ${props.borderColor}`,
    borderLeft: `${borderWidths.left}px ${borderStyle} ${props.borderColor}`,
  };
}
